export const useSlotObserver = (
  el,
  cb,
  opts = {
    childList: true,
    subtree: true,
    characterDataOldValue: true,
  }
) => {
  const observer = ref(null)

  onMounted(() => {
    observer.value = new MutationObserver(cb)
    observer.value.observe(el.value, opts)
  })

  onBeforeUnmount(() => {
    if (observer.value) {
      observer.value.disconnect()
    }
  })

  return {
    observer,
  }
}
